const AdminCertificate = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Certificat</h1>
      <p className="mt-4">Gérez les certificats de la plateforme.</p>
      <div className="mt-8 bg-white p-6 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-4">Certificats délivrés</h2>
        <p>Aucun certificat délivré pour le moment.</p>
      </div>
    </div>
  );
};

export default AdminCertificate; 